module.exports = __webpack_public_path__ + "static/img/banner5.178c567.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/banner/banner5.jpg
// module id = pVXD
// module chunks = 0